<template>
    <div class="Table-header">
        <div class="Table-row-item row--xs">
            <CustomCheckbox v-show="false" v-model="checked" />
        </div>
        <div class="Table-row-item" v-for="head in header" :key="head.name">{{ head.name }}</div>
    </div>
</template>

<script>
import CustomCheckbox from '@/components/Checkbox';

export default {
    props: ['header'],
    data() {
        return {
            checked: false,
        };
    },
    watch: {
        checked(val) {
            this.$emit('select-all', val);
        },
    },
    components: {
        CustomCheckbox,
    },
};
</script>

<style lang="scss"></style>
